import { FullPageWrapper } from "@repo/ui/index.tsx";
import UiContainer from "@/UI/Containers/UiContainer";
import ClaimCount from "@/Pages/Claims/components/ClaimsCard/ClaimCount";
import { CLAIM_DASHBOARD_ICON_2 } from "./claims.constant";
import PremiumLineChart from "@/Dashboard/PremiumCharts/PremiumChart";
import ClaimsPieChart from "@/Dashboard/ClaimsChart/ClaimsPieChart";
import ChartBar from "@/Charts/ChartBar";
import StateCityNameCard from "@/Pages/Claims/components/ClaimsCard/StateCityNameCard";
import NameStageCard from "@/Pages/Claims/components/ClaimsCard/NameStageCard";
import { NameStageData } from "./claims.constant";
import { stateCityData } from "./claims.constant";
import { BarChartdata } from "./claims.constant";
import BreadCrumb from "@/components/BreadCrumb";
function ClaimDashboardIframe() {
  return (
    <FullPageWrapper className="p-4">
      <BreadCrumb />

      <UiContainer className="grid grid-cols-4 gap-4 mt-3">
        {Object.entries(CLAIM_DASHBOARD_ICON_2).map(
          ([id, { Icon, barColor, value, label, iconClass }]) => (
            <ClaimCount
              key={id}
              icon={<Icon />}
              leftBarColor={barColor}
              labelComponent={<p className="">{label}</p>}
              valueComponent={<p className="">{value}</p>}
              iconClass={iconClass}
            />
          )
        )}
      </UiContainer>
      <UiContainer className="mt-3 flex gap-3 h-80 w-full">
        <ClaimsPieChart />
        <UiContainer className="ring-1 flex flex-col gap-3  ring-extraLightGray rounded-md h-full w-[40rem] relative">
          {/* <div className="mb-7 flex flex-row items-start gap-1 absolute top-2 left-4  rounded-md w-[130px]">
            <span className="bg-yellow-500 size-3.5 mt-1 rounded-full" />
            <p className="font-semibold ">Raised Claims</p>
          </div> */}
          <ChartBar
            dataSet={BarChartdata}
            xLabelKey="month"
            yLabelKey="sales"
            colorScheme="#D4A711"
            yLegendString="Sales"
          />
        </UiContainer>
      </UiContainer>

      <UiContainer className="mt-3 flex items-center gap-4 h-72 w-full">
        <PremiumLineChart className="flex-1" />
        <div className="rounded-lg ring-1 ring-gray/30 shadow-lg shadow-offWhite">
          <p className="font-semibold text-base py-3 pl-3">
            Claim By Locations
          </p>
          <section className="h-[15rem] overflow-auto   [&::-webkit-scrollbar]:hidden pl-3 pr-5">
            {stateCityData.map(
              ({ id, icon: Icon, city, state, value, iconClass }) => (
                <StateCityNameCard
                  key={id}
                  icon={<Icon />}
                  stateName={state}
                  cityName={city}
                  value={value}
                  iconClass={iconClass}
                />
              )
            )}
          </section>
        </div>
        <div className=" rounded-lg ring-1 ring-gray/30 shadow-lg shadow-offWhite ">
          <p className="font-semibold text-base py-3 pl-3">Recent Claims</p>
          <section className=" h-[15rem] overflow-auto  [&::-webkit-scrollbar]:hidden pl-3 pr-5 ">
            {NameStageData.map(
              ({ role, name, stage, date, coiNumber, stageColor }) => (
                <NameStageCard
                  key={coiNumber}
                  role={role}
                  name={name}
                  stage={stage}
                  date={date}
                  coiNumber={coiNumber}
                  stageColor={stageColor}
                />
              )
            )}
          </section>
        </div>
      </UiContainer>
    </FullPageWrapper>
  );
}

export default ClaimDashboardIframe;
